"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/createForOfIteratorHelper.js"));
require("core-js/modules/es6.regexp.split");
var _vuex = require("vuex");
var _importBillUpload = require("@/api/importBillUpload/importBillUpload");
var _booking = require("@/api/bookSpace/booking");
var _bankSlipConfirmDialog = _interopRequireDefault(require("./bankSlipConfirmDialog.vue"));
var _utils = require("@/utils");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "uploadInvoiceDlg",
  components: {
    bankSlipConfirmDialog: _bankSlipConfirmDialog.default
  },
  props: {
    formDialog: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    paymentNo: {
      type: String,
      default: ""
    },
    pod: {
      type: String,
      default: ""
    },
    doDof: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    amountStr: {
      type: String,
      default: ""
    },
    idBlNos: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    var _this = this;
    return {
      invoiceImInfoHistory: JSON.parse(localStorage.getItem('invoiceImInfoHistory')) || [],
      loading: null,
      bankSlipConfirmDialogVisible: false,
      acceptList: '.pdf, .jpg, .png, .bmp, .tiff',
      amountAllRMBFileList: [],
      amountAllUSDFileList: [],
      amountAllHKDFileList: [],
      amountRMBFileList: [],
      amountUSDFileList: [],
      amountHKDFileList: [],
      amountAllRMBFileFileList: [],
      fileList: [],
      poolTypeList: [],
      userInvoiceInfos: [],
      invoiceWayList: [],
      form: {
        pod: "",
        paymentNo: "",
        bankSlipDOF: "",
        extract: false,
        paymentWay: "00",
        bankSlipBlNoAndFeeId: "",
        invoiceWay: "02",
        amountRMB: "",
        amountUSD: "",
        amountHKD: "",
        amountAllRMB: "",
        amountAllUSD: "",
        amountAllHKD: "",
        receiveEmail: "",
        address: "",
        phone: "",
        accountBank: "",
        account: "",
        bankUsd: "",
        accountUsd: "",
        invoiceTaxNo: "",
        amountRMBFileId: "",
        amountUSDFileId: "",
        amountHKDFileId: "",
        amountAllRMBFileId: "",
        amountAllUSDFileId: "",
        amountAllHKDFileId: "",
        extractAmount: ""
      },
      rules: {
        paymentNo: [{
          required: true,
          message: this.$t('importBillUpload.paymentNoNotNull'),
          trigger: 'blur'
        }],
        receiveEmail: [{
          required: true,
          message: this.$t('importBillUpload.emailNotNull'),
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            if (value) {
              var emails = value.split(';');
              var _iterator = (0, _createForOfIteratorHelper2.default)(emails),
                _step;
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  var email = _step.value;
                  if (!/^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(email)) {
                    return callback(new Error(_this.$t('blExchangeAppointment.invalidEmail')));
                  }
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
            }
            callback();
          },
          trigger: ['blur', 'change']
        }],
        address: [{
          required: true,
          message: this.$t('importBillUpload.addressNotNull'),
          trigger: 'blur'
        }],
        invoiceWay: [{
          required: true,
          message: this.$t('importBillUpload.invoiceWayNotNull'),
          trigger: 'blur'
        }],
        phone: [{
          required: true,
          message: this.$t('importBillUpload.phoneNotNull'),
          trigger: 'blur'
        }, {
          validator: function validator(rule, value, callback) {
            var mobile = /^1[3456789]\d{9}$/;
            var tel = /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/;
            if (mobile.test(value) || tel.test(value)) {
              callback();
            } else {
              callback(new Error(_this.$t('blExchangeAppointment.invalidPhone')));
            }
          },
          trigger: 'blur'
        }],
        accountBank: [{
          required: true,
          message: this.$t('importBillUpload.accountBankNotNull'),
          trigger: 'blur'
        }],
        account: [{
          required: true,
          message: this.$t('importBillUpload.accountNotNull'),
          trigger: 'blur'
        }],
        invoiceTaxNo: [{
          required: true,
          message: this.$t('importBillUpload.invoiceTaxNoNotNull'),
          trigger: 'blur'
        }]
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  mounted: function mounted() {
    var _this2 = this;
    this.$dictionary.get(['DOC_INVOICE_WAY'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this2.invoiceWayList = res.DOC_INVOICE_WAY ? res.DOC_INVOICE_WAY : [];
    });
  },
  methods: {
    opened: function opened() {
      var _this3 = this;
      this.$nextTick(function () {
        _this3.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this3.form), _this3.formDialog);
        _this3.form.pod = _this3.pod;
        _this3.userInvoiceInfos = _this3.formDialog.userInvoiceInfos;
        _this3.form.paymentNo = _this3.paymentNo;
        _this3.form.bankSlipBlNoAndFeeId = _this3.idBlNos;
        if (_this3.formDialog.amountAllRMB == null || _this3.formDialog.amountAllRMB == "0" || _this3.formDialog.amountAllUSD == null || _this3.formDialog.amountAllUSD == "0" || _this3.pod != 'CNNSA' && _this3.pod != 'CNYPG' && (_this3.formDialog.amountAllHKD == null || _this3.formDialog.amountAllHKD == "0")) {
          _this3.$alert(_this3.$t('importBillUpload.noRate'), {
            confirmButtonText: _this3.$t('importBillUpload.confirm')
          });
        }
        if (!(0, _validate.validateNull)(_this3.invoiceImInfoHistory)) {
          _this3.form.paymentNo = _this3.invoiceImInfoHistory.paymentNo;
          _this3.form.receiveEmail = _this3.invoiceImInfoHistory.receiveEmail;
          _this3.form.address = _this3.invoiceImInfoHistory.address;
          _this3.form.phone = _this3.invoiceImInfoHistory.phone;
          _this3.form.accountBank = _this3.invoiceImInfoHistory.accountBank;
          _this3.form.account = _this3.invoiceImInfoHistory.account;
          _this3.form.invoiceTaxNo = _this3.invoiceImInfoHistory.invoiceTaxNo;
        }
      });
    },
    closed: function closed() {
      for (var key in this.form) {
        this.form[key] = '';
      }
      this.form.paymentWay = "00";
      this.form.invoiceWay = "01";
      this.amountAllRMBFileList = [];
      this.amountAllUSDFileList = [];
      this.amountAllHKDFileList = [];
      this.amountRMBFileList = [];
      this.amountUSDFileList = [];
      this.amountHKDFileList = [];
      this.$emit('handleUploadInvoiceDlg');
    },
    uploadAmountAllRMBFile: function uploadAmountAllRMBFile(item) {
      var _this4 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.amountAllRMBFileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.amountAllRMBFileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.amountAllRMBFileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this4.form.amountAllRMBFileId = res.fileId;
        } else {
          _this4.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this4.loading.close();
      });
    },
    handleAmountAllRMBFile: function handleAmountAllRMBFile() {
      var _this5 = this;
      (0, _booking.deleteByFileId)(this.form.amountAllRMBFileId).then(function (res) {
        if (res == "success") {
          _this5.form.amountAllRMBFileId = "";
          _this5.$message.success(_this5.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this5.$message.warning(res.errorMessages[0]);
        }
      });
    },
    uploadAmountAllUSDFile: function uploadAmountAllUSDFile(item) {
      var _this6 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.amountAllUSDFileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.amountAllUSDFileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.amountAllUSDFileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this6.form.amountAllUSDFileId = res.fileId;
        } else {
          _this6.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this6.loading.close();
      });
    },
    handleAmountAllUSDFile: function handleAmountAllUSDFile() {
      var _this7 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.deleteByFileId)(this.form.amountAllUSDFileId).then(function (res) {
        if (res == "success") {
          _this7.form.amountAllUSDFileId = "";
          _this7.$message.success(_this7.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this7.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this7.loading.close();
      });
    },
    uploadAmountAllHKDFile: function uploadAmountAllHKDFile(item) {
      var _this8 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.amountAllHKDFileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.amountAllHKDFileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.amountAllHKDFileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this8.form.amountAllHKDFileId = res.fileId;
        } else {
          _this8.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this8.loading.close();
      });
    },
    handleAmountAllHKDFile: function handleAmountAllHKDFile() {
      var _this9 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.deleteByFileId)(this.form.amountAllHKDFileId).then(function (res) {
        if (res == "success") {
          _this9.form.amountAllHKDFileId = "";
          _this9.$message.success(_this9.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this9.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this9.loading.close();
      });
    },
    uploadAmountRMBFile: function uploadAmountRMBFile(item) {
      var _this10 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.amountRMBFileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.amountRMBFileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.amountRMBFileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this10.form.amountRMBFileId = res.fileId;
        } else {
          _this10.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this10.loading.close();
      });
    },
    handleAmountRMBFile: function handleAmountRMBFile() {
      var _this11 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.deleteByFileId)(this.form.amountRMBFileId).then(function (res) {
        if (res == "success") {
          _this11.form.amountRMBFileId = "";
          _this11.$message.success(_this11.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this11.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this11.loading.close();
      });
    },
    uploadAmountUSDFile: function uploadAmountUSDFile(item) {
      var _this12 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.amountUSDFileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.amountUSDFileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.amountUSDFileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this12.form.amountUSDFileId = res.fileId;
        } else {
          _this12.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this12.loading.close();
      });
    },
    handleAmountUSDFile: function handleAmountUSDFile() {
      var _this13 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.deleteByFileId)(this.form.amountUSDFileId).then(function (res) {
        if (res == "success") {
          _this13.form.amountUSDFileId = "";
          _this13.$message.success(_this13.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this13.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this13.loading.close();
      });
    },
    uploadAmountHKDFile: function uploadAmountHKDFile(item) {
      var _this14 = this;
      if (item.file.size > 10 * 1024 * 1024) {
        this.$message.warning(this.$t('blExchangeAppointment.fileSize'));
        this.amountHKDFileList = [];
        return;
      }
      var validTypes = ['application/pdf', 'image/jpeg', 'image/png', 'image/bmp', 'image/tiff'];
      if (!validTypes.includes(item.file.type)) {
        this.$message.warning(this.$t('blExchangeAppointment.fileFormat'));
        this.amountHKDFileList = [];
        return;
      }
      if (item.file.name.length > 40) {
        this.$message.warning(this.$t('blExchangeAppointment.attachmentFileLength'));
        this.amountHKDFileList = [];
        return;
      }
      this.loading = (0, _utils.load)();
      var formDatas = new FormData();
      formDatas.append("file", item.file);
      formDatas.append("bucket", 'commerce');
      (0, _booking.setUploadFile)(formDatas).then(function (res) {
        if (res.code) {
          _this14.form.amountHKDFileId = res.fileId;
        } else {
          _this14.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this14.loading.close();
      });
    },
    handleAmountHKDFile: function handleAmountHKDFile() {
      var _this15 = this;
      this.loading = (0, _utils.load)();
      (0, _booking.deleteByFileId)(this.form.amountHKDFileId).then(function (res) {
        if (res == "success") {
          _this15.form.amountHKDFileId = "";
          _this15.$message.success(_this15.$t('roleCertificationApplication.deleteMessage'));
        } else {
          _this15.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this15.loading.close();
      });
    },
    beforeRemove: function beforeRemove(file) {
      return this.$confirm("\u786E\u5B9A\u79FB\u9664 ".concat(file.name, "\uFF1F"));
    },
    handleCheckboxChange: function handleCheckboxChange(value) {
      var _this16 = this;
      if (value) {
        this.loading = (0, _utils.load)();
        (0, _importBillUpload.doBtnClickDOF)(this.doDof).then(function (res) {
          if (res.success) {
            _this16.form.amountRMB = res.data.amountRMB;
            _this16.form.amountUSD = res.data.amountUSD;
            _this16.form.amountHKD = res.data.amountHKD;
            _this16.form.amountAllRMB = res.data.amountAllRMB;
            _this16.form.amountAllUSD = res.data.amountAllUSD;
            _this16.form.amountAllHKD = res.data.amountAllHKD;
          }
        }).finally(function () {
          _this16.loading.close();
        });
      } else {
        this.loading = (0, _utils.load)();
        (0, _importBillUpload.openDialog)(this.amountStr, this.idBlNos).then(function (res) {
          if (res.success) {
            _this16.form.amountRMB = res.data.amountRMB;
            _this16.form.amountUSD = res.data.amountUSD;
            _this16.form.amountHKD = res.data.amountHKD;
            _this16.form.amountAllRMB = res.data.amountAllRMB;
            _this16.form.amountAllUSD = res.data.amountAllUSD;
            _this16.form.amountAllHKD = res.data.amountAllHKD;
          }
        }).finally(function () {
          _this16.loading.close();
        });
      }
    },
    // 针对蛇口判断是否上传对应水单
    handleValidateUpload: function handleValidateUpload() {
      if (this.pod === 'CNSHK') {
        if (this.form.paymentWay === '00' && (this.form.amountRMB !== 0 && (0, _validate.validateNull)(this.form.amountRMBFileId) || this.form.amountUSD !== 0 && (0, _validate.validateNull)(this.form.amountUSDFileId) || this.form.amountHKD !== 0 && (0, _validate.validateNull)(this.form.amountHKDFileId))) {
          return true;
        } else if (this.form.paymentWay === '01' && this.form.amountAllRMB !== 0 && (0, _validate.validateNull)(this.form.amountAllRMBFileId)) {
          return true;
        } else if (this.form.paymentWay === '02' && this.form.amountAllUSD !== 0 && (0, _validate.validateNull)(this.form.amountAllRMBFileId)) {
          return true;
        } else if (this.form.paymentWay === '03' && this.form.amountAllHKD !== 0 && (0, _validate.validateNull)(this.form.amountAllHKDFileId)) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    addInvoiceImInfoHistory: function addInvoiceImInfoHistory() {
      var obj = {
        paymentNo: this.form.paymentNo,
        receiveEmail: this.form.receiveEmail,
        address: this.form.address,
        phone: this.form.phone,
        accountBank: this.form.accountBank,
        account: this.form.account,
        invoiceTaxNo: this.form.invoiceTaxNo
      };
      this.invoiceImInfoHistory = obj;
      localStorage.setItem('invoiceImInfoHistory', JSON.stringify(this.invoiceImInfoHistory));
    },
    handleSave: function handleSave() {
      var _this17 = this;
      if (this.form.paymentNo.indexOf("进口客户") != -1) {
        this.$message.error(this.$t('importBillUpload.modPaymentNo'));
        return;
      }
      this.$refs['form'].validate(function (valid) {
        if (valid) {
          _this17.addInvoiceImInfoHistory();
          if (_this17.handleValidateUpload()) {
            _this17.$confirm(_this17.$t('exportCostSlipUpload.notUploadFile'), _this17.$t('confirmMsg.title'), {
              confirmButtonText: _this17.$t('confirmMsg.submit'),
              cancelButtonText: _this17.$t('confirmMsg.cancel'),
              type: 'warning'
            }).then(function () {
              _this17.bankSlipConfirmDialogVisible = true;
            }).catch(function () {
              return;
            });
          } else {
            _this17.bankSlipConfirmDialogVisible = true;
          }
        }
      });
    },
    handleBankSlipConfirmSave: function handleBankSlipConfirmSave() {
      var _this18 = this;
      this.bankSlipConfirmDialogVisible = false;
      this.loading = (0, _utils.load)();
      (0, _importBillUpload.bankSlipSave)(this.form).then(function (res) {
        if (res.success) {
          _this18.$message.success(_this18.$t('importBillUpload.saveSuccessfully'));
          _this18.closed();
        } else {
          _this18.$message.warning(res.errorMessages[0]);
        }
      }).finally(function () {
        _this18.loading.close();
      });
    }
  }
};